import React, { useState } from "react";
import {
  AccordionContainer,
  ContentWrapper,
  AccordionWrapper,
  TitleWrapper,
  Wrapper,
} from "./index.styled";
import { HiOutlinePlusSm, HiMinusSm } from "react-icons/hi";
const Accordion = () => {
  const [selected, setSelected] = useState(null);

  const toggleHandler = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };
  const QuestionsData = [
    {
      id: 1,
      content:
        "برای اینکه محصول هوشمند آوانگار را دریافت کنید و در کسب وکار خود از آن بهره مند شوید، باید وب سرویس ابری مبتنی بر هوش مصنوعی آوانگار را در کدهای پلتفرم های خود مورد استفاده قرار دهید. در این صورت قادر خواهید بود به راحتی از این وب سرویس هوشمند استفاده کنید.",
      title: "آوانگار چگونه ارائه میشود؟",
    },
    {
      id: 2,
      content:
        "ارائه خروجی به صورت یک متن قابل ویرایش-اضافه کردن خودکار علائم نگارشی به متن خروجی-دقت بالا در تشخیص گفتار و عبارات-سرعت زیاد تبدیل گفتار به متن-امکان فیلترکردن واژگان دلخواه از سوی کاربر-توانایی تشخیص صحیح گفتار در محیط های شلوغ و نویزی-امکان تشخیص گفتار با لهجه ها و گویش های گوناگون فارسی ایرانی-تشخیص و تمیز دادن گویندگان متفاوت از هم - توانایی تشخیص گفتار محاوره - شخصی سازی مدل برای محیط ها و شرایط خاص",
      title: "ویژگی های آوانگار چیست؟",
    },
    {
      id: 3,
      content:
        "آوانگار برای تمام کاربرانی که ثبت نام میکنند در ابتدا یک اعتبار رایگان در نظر میگیرد تا کاربر بتواند به صورت رایگان از سرویس آوانگار استفاده کند و با مزایا و قابلیت های آن آشنا شود. در ادامه در صورت رضایت و نیاز کاربر به افزایش اعتبار به راحتی میتواند کیف پول خود را شارژ کند و از سرویس های آوانگار لذت ببرد.",
      title: "چگونه به صورت رایگان از آوانگار استفاده کنیم؟",
    },
    // {
    //   id: 4,
    //   content:
    //     "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته،",
    //   title: "سرویس های آوانگار چگونه ارائه می‌شوند؟",
    // },
  ];
  return (
    <AccordionContainer>
      <AccordionWrapper>
        {QuestionsData.map((item, i) => (
          <Wrapper key={item.id}>
            <TitleWrapper onClick={() => toggleHandler(i)}>
              <div>
                <h2>{item.title}</h2>
              </div>

              <div
                className={
                  selected === i ? "icon-wrapper show" : "icon-wrapper"
                }
              >
                {selected === i ? <HiMinusSm /> : <HiOutlinePlusSm />}
              </div>
            </TitleWrapper>
            <ContentWrapper
              className={selected === i ? "content show" : "content"}
            >
              {item.content}
            </ContentWrapper>
          </Wrapper>
        ))}
      </AccordionWrapper>
    </AccordionContainer>
  );
};

export default Accordion;
